
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/pdf/[[...path]]",
      function () {
        return require("private-next-pages/[site]/pdf/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[site]/pdf/[[...path]]"])
      });
    }
  